import { createContext, useContext, useState } from 'react';

import { FLIX_THEME_DARK, FLIX_THEME_DEFAULT, THEME_STORAGE_KEY } from './const';

export const ThemeContext = createContext();

export const useFlixTheme = () => {
	const context = useContext(ThemeContext);
	if (!context) {
		throw new Error('useFlixTheme must be used within a FlixThemeProvider');
	}
	return context;
};

export const useFlixThemeState = () => {
	// Load theme from localStorage
	const [theme, setTheme] = useState(() => {
		const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
		return storedTheme || FLIX_THEME_DEFAULT;
	});

	const isDark = theme.match(/-dark/);

	const toggleTheme = () => {
		const newTheme = isDark ? FLIX_THEME_DEFAULT : FLIX_THEME_DARK;
		setTheme(newTheme);
		localStorage.setItem(THEME_STORAGE_KEY, newTheme);
	};

	return { theme, toggleTheme, isDark };
};
